import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

const CustomCheck = ({ isChecked, onChange, id, disabled }) => (
  <div
    style={{
      backgroundColor: '#F7F7F7',
      padding: '10px',
      display: 'flex',
      alignItems: 'center',
      margin: '0'
    }}
  >
    <Form.Check
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer'
      }}
    >
      <Form.Check.Input
        checked={isChecked}
        disabled={disabled}
        id={id}
        onChange={onChange}
        style={{
          backgroundColor: disabled ? 'gray' : ''
        }}
        type="checkbox"
      />
    </Form.Check>
  </div>
);

CustomCheck.propTypes = {
  isChecked: PropTypes.bool,
  id: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

CustomCheck.defaultProps = {
  isChecked: false,
  id: 0,
  disabled: false
};

export default CustomCheck;
